import React from "react";
import { createRoot } from "react-dom/client";
import DiProvider from "../../di-context/Provider";
import { ModalContext, useModal } from "./context";

export { useModal, ModalContext };

export const render = (ModalComponent, props, container) =>
	new Promise((resolve, reject) => {
		const node = document.createElement("div");
		document.body.appendChild(node);

		const onClose = result => {
			document.body.removeChild(node);
			resolve(result);
		};
		const onError = error => {
			document.body.removeChild(node);
			reject(error);
		};

		const root = createRoot(node);
		root.render(
			<ModalContext {...{ onClose, onError }}>
				{container ? (
					<DiProvider container={container} data={props}>
						<ModalComponent {...props} />
					</DiProvider>
				) : (
					<ModalComponent {...props} />
				)}
			</ModalContext>,
		);
	});
